import { render } from "./CatDailyGoal.vue?vue&type=template&id=2f80ba25&scoped=true"
import script from "./CatDailyGoal.vue?vue&type=script&lang=js"
export * from "./CatDailyGoal.vue?vue&type=script&lang=js"

import "./CatDailyGoal.vue?vue&type=style&index=0&id=2f80ba25&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f80ba25"]])

export default __exports__